import { Component, EventEmitter, Input, Output } from '@angular/core';

import { OutlineRow } from '../page/page-structure';
import { END } from './suburb-template';

/**
 * A suburb page's outline (#262): the template's blocks in order (each shown, or hidden and why) and the blocks inserted
 * on this page between them. Read-only for the template's "Preview as"; in a suburb's Page tab it also offers "Add a
 * block here" under each template block and at the end, and Edit, Move and Delete on inserted blocks. Presentational:
 * it says what was asked for and its host does it.
 */
@Component({
  selector: 'app-page-outline',
  templateUrl: './page-outline.component.html',
  styleUrls: ['./page-outline.component.scss'],
})
export class PageOutlineComponent {
  @Input() rows: OutlineRow[] = [];
  /** Offer the inserted blocks' controls. */
  @Input() editable = false;
  /** The page's name, for "only on Randwick". */
  @Input() pageName = '';
  /** Where a new block goes: after this template block id, or the end. */
  @Output() add = new EventEmitter<string>();
  @Output() edit = new EventEmitter<string>();
  @Output() move = new EventEmitter<{ id: string; dir: -1 | 1 }>();
  @Output() remove = new EventEmitter<string>();

  readonly end = END;

  /** The first line is the hero: nothing moves above it. */
  canMoveUp(i: number): boolean {
    return i > 1;
  }

  canMoveDown(i: number): boolean {
    return i < this.rows.length - 1;
  }

  trackRow(_: number, row: OutlineRow): string {
    return row.id;
  }
}
